import { render, staticRenderFns } from "./Esports.vue?vue&type=template&id=67ed12ce&scoped=true"
import script from "./Esports.vue?vue&type=script&setup=true&lang=js"
export * from "./Esports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Esports.vue?vue&type=style&index=0&id=67ed12ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed12ce",
  null
  
)

export default component.exports